export default __webpack_public_path__ + "static/media/FlipkartLogo1.3dd2324c.png";